﻿function getrecommanded() {
    showWait();
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/lives/recommanded?page=1&size=3&type=0&state=2',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                if (result.error == undefined) {
                    var isAdd = false;
                    for (var i = 0; i < result.data.length; i++) {
                        var info = result.data[i];
                        if (info.cover_url == null || info.cover_url.length == 0) {
                            continue;
                        }
                        isAdd = true;

                        var html = '<div class="scrollview-right-item" data-info=\'' + info + '\'>' +
                            '<a target="_blank" href="/room/' + info.id + '">' +
                            '<img src="' + info.cover_url + '?w=295&h=137&s=3">' +
                            '<div class="scrollview-right-item-bk"></div>' +
                            '</a>' +
                            '</div>';
                        $('.scrollview-right').append(html);

                        if (i == 0) {
                            $('#poster-main-a').attr('href', '/room/' + info.id);
                            $('#poster-main-img').attr('src', info.cover_url + '?w=898&h=420&s=3');
                        }
                    }

                    if (isAdd) {
                        $('.scrollview').show();
                    }
                } else {
                    // alert(result.message);
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            // alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();
        }
    });
}

// getrecommanded();

function getrecommanded2() {
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/lives/recommanded?page=1&size=3&type=0&state=2',
        // url: ROOT + '/lives/search?page=1&size=12&type=2',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result && result.data && result.data.length > 0) {
                $('#partial-view').html('');
                var isAdd = false;

                if (result.data.length == 1) {
                    result.data.push(result.data[0]);
                    result.data.push(result.data[0]);
                } else if (result.data.length == 2) {
                    result.data.push(result.data[0]);
                }

                for (var i = 0; i < result.data.length; i++) {
                    var info = result.data[i];
                    if (info.cover_url == null || info.cover_url.length == 0) {
                        continue;
                    }
                    isAdd = true;

                    var html = '<li>' +
                        '<a target="_blank" href="' + ROOT + '/room/' + info.id + '">' +
                        '<img src="' + info.cover_url + '?w=676&h=280&s=3" width="676" height="280">' +
                        '</a>' +
                        '</li>';

                    $('#partial-view').append(html);
                }

                if (isAdd) {
                    $('.scrollview2').show();

                    var css = 'background: url(' + ROOT + '/static/partialviewslider/btn.png);background-size:20px 30px;';
                    $('#partial-view').partialViewSlider({
                        width: 686 / 1110 * 100,
                        prevHtml: '<i class="material-icons material-icons-prev" style="' + css + '"></i>',
                        nextHtml: '<i class="material-icons material-icons-next" style="' + css + '"></i>',
                    });
                }
            } else {
                // alert(result.message);
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            // alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();
        }
    });
}

$(function () {
    getrecommanded2();

    gethotest(12);

    gethotest2(24);

    $('.showtab').click(function () {
        $('.active').removeClass('active');
        $(this).addClass('active');

        if ($(this).data('type') == 2) {
            $('.curentlives').hide();
            $('.curentlives2').show();
        } else {
            $('.curentlives').show();
            $('.curentlives2').hide();
        }
    });
});
